import React from 'react';
import AzulejoPanel from '../AzulejoPanel';
import PinPolaroid from '../PinPolaroid';
import PetIllustration from '../PetIllustration';
import WatercolorWash from '../WatercolorWash';
import type { IllustrationSpec } from '../../types';
import '../../styles/Hero.css';

interface HeroMeta {
  left: string;
  right: string;
}

interface HeroCta {
  label: string;
  href: string;
}

export interface HeroCoverPet {
  name: string;
  caption: string;
  stamp: string;
  illustration: IllustrationSpec;
}

interface HeroProps {
  meta?: HeroMeta;
  coverPet?: HeroCoverPet;
  primaryCta?: HeroCta;
  secondaryCta?: HeroCta;
}

const DEFAULT_COVER: HeroCoverPet = {
  name: 'Biscoito',
  caption: 'Biscoito · ch. 03',
  stamp: 'espera\nhá 4 meses',
  illustration: {
    kind: 'dog',
    variant: 'default',
    palette: {
      bg: '#c68c3b',
      body: '#0f2a4a',
      eyes: '#f3ead8',
      mouth: '#f3ead8',
    },
  },
};

const Hero: React.FC<HeroProps> = ({
  meta = { left: 'Est. 2019 · Silvalde, Espinho', right: '— primavera de 2026' },
  coverPet = DEFAULT_COVER,
  primaryCta = { label: 'Conhecer os pequenos →', href: '#pets' },
  secondaryCta = { label: '… ou ajudar com uma doação', href: '#help' },
}) => (
  <section className="hero">
    <WatercolorWash variant="a" color="#c68c3b" style={{ top: '-80px', left: '-60px' }} />

    <div className="hero__copy rise">
      <div className="hero__meta">
        {meta.left}
        <span className="hand">{meta.right}</span>
      </div>

      <h1 className="hero__title">
        Uma casa<br />
        para <em>cada</em> pata<br />
        <span className="hero__marker">cansada</span>
        <span className="hero__amp">&amp;</span><br />
        <span className="hero__scribble">à espera</span>
      </h1>

      <p className="hero__lede">
        Somos um pequeno abrigo junto ao mar que recolhe cães e gatos que
        perderam o rumo. Tratamos, recuperamos, apresentamos — e esperamos
        <em> com paciência </em>
        que cheguem a casa.
      </p>

      <div className="hero__cta">
        <a className="btn btn--primary" href={primaryCta.href}>{primaryCta.label}</a>
        <a className="hero__scribbled" href={secondaryCta.href}>{secondaryCta.label}</a>
      </div>
    </div>

    <div className="hero__visual">
      <AzulejoPanel stamp="Silvalde · Azulejo nº 117" />
      <div className="hero__pin">
        <PinPolaroid
          variant="hero"
          caption={coverPet.caption}
          stamp={coverPet.stamp}
          tapeColor="ochre"
          media={
            <PetIllustration
              kind={coverPet.illustration.kind}
              variant={coverPet.illustration.variant}
              palette={coverPet.illustration.palette}
            />
          }
        />
      </div>
    </div>
  </section>
);

export default Hero;
